export function Meter({ value, max, label, detail }: { value: number; max: number; label?: React.ReactNode; detail?: React.ReactNode }) {
  const ratio = max > 0 ? Math.min(value / max, 1) : 0;
  const tone = value / max >= 1 ? "crit" : value / max >= 0.85 ? "warn" : "";
  return (
    <div className={`meter ${tone}`}>
      {(label || detail) && (
        <div className="meter-row">
          <span>{label}</span>
          <span>{detail}</span>
        </div>
      )}
      <div className="meter-track" role="meter" aria-valuemin={0} aria-valuemax={max} aria-valuenow={value}>
        <div className="meter-fill" style={{ width: `${ratio * 100}%` }} />
      </div>
    </div>
  );
}
